
import React from 'react';
 
const languageContext = React.createContext(null);
export default languageContext;
